// extracted by mini-css-extract-plugin
module.exports = {"main-modal":"modal-container_main-modal__1l_ck","second-modal":"modal-container_second-modal__1G8gZ"};